export enum LineHeight {
  xxl = '1.1',
  xl = '1.2',
  l = '1.3',
  m = '1.5',
  s = '1.4',
  xs = '1.3',
}
